import EventNoteIcon from '@mui/icons-material/EventNote'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { GetPaymentResultDTO } from '@src/api/@types/GetPaymentResultDTO'
import { formatDays } from '@src/services/Formatter'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  payments?: GetPaymentResultDTO[]
  closedNextPayment?: boolean
  daysToNextPayment?: string
}

const PaymentsInfo: FC<Props> = ({ payments, closedNextPayment , daysToNextPayment }) => {
  const { t } = useTranslation()

  if (!payments || payments.length === 0 || closedNextPayment) {
    return null
  }
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h5" sx={{ fontWeight: 200, mb: 1 }}>
          {t('payment.nextPayment')}
        </Typography>
        {payments.map((payment) => (
          <Box key={payment.id} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body2" sx={{ color: 'gray', fontWeight: 400, mb: 1 }}>
              {formatDays(payment.plannedOnDateUTC)}
            </Typography>
            <Stack spacing={2}>
              <Typography sx={{ fontWeight: 200, mb: 1 }}>
                <Box component="span" sx={{ fontSize: '4rem', color: 'white' }}>
                  {Math.floor(payment.amount)}
                </Box>
                <Box component="span" sx={{ fontSize: '4rem', color: 'gray' }}>
                  .{(payment.amount % 1).toFixed(2).split('.')[1]}$
                </Box>
                <Box component="span" sx={{ color: 'gray' }}>
                  / {t('payment.month')}
                </Box>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', color: 'white', fontWeight: 200, mt: 0 }}>
                <EventNoteIcon sx={{ mr: 1 }} />  {daysToNextPayment}
              </Box>
            </Stack>
          </Box>
        ))}
      </Box>
    </>
  )
}

export default PaymentsInfo
